export default "__VITE_PUBLIC_ASSET__a1889e2a__"